import LockKeyholeIcon from '@components/v2/icons/LockKeyhole';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { LockKeyholeOpen } from 'lucide-react';
import { useShallow } from 'zustand/react/shallow';
import LangEnum from '../../lang/LangEnum';
import { useTranslation } from '../../modules/translation/TranslationContext';
import useGeneralSettingsStore from '../../stores/GeneralSettings/useGeneralSettingsStore';

interface ProductLockProps {
  isLocked: boolean;
  onClick: () => void;
}

const ProductLock = ({ isLocked, onClick }: ProductLockProps) => {
  const { translate } = useTranslation();

  const { productInputLockValue } = useGeneralSettingsStore(
    useShallow((state) => ({
      productInputLockValue: state.generalSettings.productInputLockValue,
    })),
  );

  const lockIcon = isLocked ? LockKeyholeIcon : LockKeyholeOpen;
  const tooltipContent = translate(LangEnum.PRODUCT_INPUT_UNLOCK_MESSAGE, {
    max: productInputLockValue,
  });

  return (
    <Tooltip TooltipContent={tooltipContent} placement="top" tabIndex={-1}>
      <IconButton
        icon={lockIcon}
        color="secondary"
        size="medium"
        shape="round"
        isActive={!isLocked}
        ariaLabel={tooltipContent}
        onClick={onClick}
      />
    </Tooltip>
  );
};

export default ProductLock;
